<template>
  <div class="loginDiv">
    <div class="logo">
      <img src="../assets/img/logo.png" alt="" width="73%" />
    </div>
    <div class="cont1">
      玖龙智通合作单位协作系统
    </div>
    <div class="cont2">
      <van-field
        v-model="account"
        label="账号"
        placeholder="请输入账号"
        style="margin-bottom: 10px;padding: 14px 16px;"
      />
      <van-field
        v-model="pwd"
        type="password"
        label="密码"
        placeholder="请输入密码"
        style="margin-bottom: 10px;padding: 14px 16px;border-bottom: 1px solid #ececec;"
      />
      <van-field
        v-if="captchaCodeUrl.length > 0"
        v-model="code"
        label="验证码"
        placeholder="请输入验证码"
        style="margin-bottom: 10px;padding: 14px 16px;border-bottom: 1px solid #ececec;"
      >
        <template #button>
          <img
            class="captchaCodeImg"
            @click="changeCaptchaCodeUrl"
            :src="captchaCodeUrl"
            alt=""
          />
        </template>
      </van-field>
    </div>
    <div class="btn">
      <van-button type="primary" block style="font-size: 18px;" @click="login"
        >登录</van-button
      >
    </div>
    <div class="cont-footer" v-if="showFooter">
      玖龙智通纸业有限公司版权所有
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      account: "",
      pwd: "",
      openid: "",
      comId: "",
      captchaCodeUrl: "",
      code: "",
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      realHeight: 0, //实时屏幕高度
      showFooter: true //显示底部fixed
    };
  },
  watch: {
    realHeight: function() {
      //如果默认高度大于实际高度则影藏，反之就显示
      if (this.docmHeight > this.realHeight) {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    }
  },
  created() {
    this.openid = this.$common._getQuery("openid");
    this.comId = this.$common._getQuery("comId");
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        // 实时屏幕高度
        this.realHeight = document.body.clientHeight;
      })();
    };
  },
  methods: {
    ...mapActions(["fetchPrivilege"]),
    changeCaptchaCodeUrl() {
      this.captchaCodeUrl =
        "/api/authorize/get_captcha?account=" +
        this.account +
        "&t=" +
        new Date().getTime();
    },
    login() {
      if (this.account.trim() === "") {
        this.$common.mbToastFail("账号不能为空");
        return false;
      }
      if (this.pwd.trim() === "") {
        this.$common.mbToastFail("密码不能为空");
        return false;
      }

      this.$common
        .http({
          url: "/api/authorize/ext_account_login",
          data: {
            account: this.account,
            password: this.pwd,
            openid: this.openid,
            com_id: this.comId,
            code: this.code
          }
        })
        .then(res => {
          // 从新设置token
          if (res.data.errcode == 0) {
            const token = res.data.data.token;
            // window.localStorage.removeItem("token");
            // window.localStorage.setItem("token", token);
            // token 值
            let projectNameArray = window.location.pathname.split("/");
            let projectName = (projectNameArray[1] || "") + "token";
            window.localStorage.removeItem(projectName);
            window.localStorage.setItem(projectName, token);
            this.fetchPrivilege();
            // 判断是否完善资料
            this.$common
              .http({
                url: "/api/supplier/account_info"
              })
              .then(res1 => {
                let isReset = Number(res1.data.data.reset_password);
                let isComplete = Number(res1.data.data.is_complete);

                if (isReset === 1 && isComplete === 1) {
                  // 跳转合作单位页面 rhwxWelcome
                  this.$router.push({ path: "/rhwxWelcome" });
                } else if (isReset === 1 && isComplete === 0) {
                  // rhwxInfoModify
                  this.$router.push({
                    path: "/rhwxInfoModify",
                    query: {
                      is_complete: isComplete
                    }
                  });
                } else if (isReset === 0) {
                  this.$router.push({
                    path: "/rhwxPwdModify",
                    query: {
                      is_reset: isReset
                    }
                  });
                }
              });
          } else {
            this.captchaCodeUrl =
              "/api/authorize/get_captcha?account=" +
              this.account +
              "&t=" +
              new Date().getTime();
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.loginDiv {
  padding: 16px;
  .logo {
    text-align: center;
    padding: 33px 27px 39px;
  }
  .cont1 {
    font-size: 25px;
    color: #333333;
    letter-spacing: 0.96px;
    line-height: 40px;
    text-align: center;
  }
  .btn {
    padding: 22px 0px 30px;
  }
  .cont2 {
    margin: 26px 0px 40px 0px;
  }
  .cont-footer {
    text-align: center;
    font-size: 14px;
    color: #999999;
    padding: 0px 0px 20px;
    position: fixed;
    width: calc(100vw - 32px);
    bottom: 0px;
  }
  .captchaCodeImg {
    width: 100px;
    position: absolute;
    right: 0;
    top: -6px;
  }
}
</style>
<style lang="less">
.loginDiv {
  .van-cell {
    line-height: 24px;
    font-size: 18px;
    color: #333333;
    background-color: #fff;
  }
  .van-field__label {
    width: 4.65em;
  }
}
</style>
